export default __webpack_public_path__ + "media/images/old_logo-5fc4e6d35c4cd8e7638aecb5c9f4a702.png";